module.exports = __webpack_public_path__ + "img/spirit_light_grey_ba_detail_rsh1(1).250b47a2.jpg";